import { MMW_URL } from "assets/constant";
import {
  getWeddingHallBlock,
  getWeddingList,
  IWeddingListRequest,
  THallPhotos,
} from "data/company";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  userSelectFittableHall,
  userSelectHall,
  userState,
} from "recoil/atoms";
import {
  BottomButton,
  ItemList,
  Layout,
  SearchBox,
  StickyContent,
  Title,
  Icon,
  Alert,
} from "../../components";
import styles from "./style.module.css";
import { throttle } from "lodash";
import { toast, ToastContainer } from "react-toastify";
import Lottie from "lottie-react";
import { loadingLottie } from "assets/lottie";
import { SvgLoadingImage } from "assets";
import useInfiniteScroll from "hooks/useInfiniteScroll";
import { getParameterObject } from "utils/common";
import { recombinationListState } from "recoil/company";
import { IInquiry } from "pages/InquiryBoxList/InquiryBoxList";
import { gray4, redLightColor } from "assets/styleUtils";
import useInitData from "hooks/useInitData";
import { FixedModal } from "modal";
import PopupModal from "modal/PopupModal/PopupModal";
import moment from "moment";

export type THall = {
  hall_name?: string | null;
  hall_type?: string | null;
  hall_term?: string | null;
  hall_max?: string | null;
  hall_style?: string | null;
  meal_type?: string | null;
  min_headcount?: string | null;
  hall_headcount?: string | null;
  max_headcount?: string | null;
  checked: boolean;
  no: number;
  photos?: THallPhotos[];
};

export type THallList = {
  imgUrl: string;
  name: string;
  checked: boolean;
  contructor_no: number;
  hall?: THall[];
  booked?: boolean;
};

export type TParams = {
  txt?: string;
};

//로컬스토리지 하루동안보지않기
export const closePopup = (expireDays: number) => {
  let expire = new Date();
  expire.setTime(expire.getTime() + expireDays * 24 * 60 * 60 * 1000);
  localStorage.setItem("popupNoShow", expire.getTime().toString());
};

export const checkPopupClose = () => {
  const expireDay = localStorage.getItem("popupNoShow");
  let today = new Date();

  if (today.getTime() > Number(expireDay)) {
    return false;
  } else {
    return true;
  }
};

export default function WeddingHall() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const { txt } = getParameterObject({ url: search });
  const decodedTxt: string | undefined =
    decodeURIComponent(txt) === "undefined"
      ? undefined
      : decodeURIComponent(txt);
  const recommend = decodedTxt === "recommend";
  const userHallData = useRecoilValue(userSelectHall);
  const userFittablaData = useRecoilValue(userSelectFittableHall);
  const user = useRecoilValue(userState);
  const [showAlert, setShowAlert] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const closePopupToday = () => {
    closePopup(1);
    setShowPopup(false);
  };
  useEffect(() => {
    checkPopupClose() ? setShowPopup(false) : setShowPopup(true);
  }, []);

  //city 선택
  const cityArray = [
    ...new Set(
      (userFittablaData.wantCity || []).map(
        (city: string) => city.split("-")[0],
      ),
    ),
  ];
  //filter_list
  let combinedArray: number[] = [];
  for (let [key, value] of Object.entries(userFittablaData)) {
    if (key !== "wantLocation" && key !== "wantCity") {
      let numericValue;
      if (Array.isArray(value)) {
        numericValue = value[0]?.split(",").map(Number);
      } else {
        numericValue = value.map(Number);
      }
      combinedArray = combinedArray.concat(numericValue);
      combinedArray = combinedArray.filter((num) => num !== 0);
    }
  }

  const [contructorList, setContructorList] = useState<THallList[]>([]);
  const [paging, setPaging] = useState<IPage>();
  const [searchText, setSearchText] = useState(
    (!recommend && decodedTxt) || "",
  );
  const [selectArray, setSelectArray] = useRecoilState(userSelectHall);

  const recombinationList = useRecoilValue(recombinationListState);
  const [inquiryBoxList, setInquiryBoxList] =
    useState<IInquiry[]>(recombinationList);
  //접수취소완료, 예약취소완료된 것 제외, 중복된 것 제외한 리스트
  const reArrangeList = inquiryBoxList
    .filter((data) => !data.counsel_cancel_day)
    .filter((data) => data.status !== 3)
    .reduce<IInquiry[]>((acc, current) => {
      const isDuplicate = acc.some(
        (item) => item.contructor_no === current.contructor_no,
      );
      if (!isDuplicate) {
        acc.push(current);
      }
      return acc;
    }, []);

  const [isInit, setIsInit] = useState(true);
  const [page, setPage] = useState(1);
  const listRef = useRef<HTMLDivElement | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [totalPages, setTotalPages] = useState(0);
  const { getInquiryList } = useInitData();
  const [reserveStatus, setReserveStatus] = useState({
    status: false,
    blockTime: "",
  });
  const [block, setBlock] = useState(false);

  const selectComplete = selectArray.map((_selectItem) => {
    const filteredHalls =
      _selectItem.hall?.filter((_hall) => _hall.checked) || [];

    return {
      name: _selectItem.name,
      contructor_no: _selectItem.contructor_no,
      hall: filteredHalls,
    };
  });

  const containsEmptyArray = selectComplete.filter((array, idx) => {
    if ((array || []).hall.length === 0) {
      return selectComplete[idx].name;
    }
  });

  const viewContructorList = contructorList.map((item) => {
    const isBooked = reArrangeList.some(
      (checkedItem) => checkedItem.contructor_no === item.contructor_no,
    );
    const checkValue = selectArray.find(
      (value) => value.contructor_no === item.contructor_no,
    );
    const checkHallValue = item?.hall?.map((_hall) => {
      const checkedHall = checkValue?.hall?.find(
        (_prev) => _prev.no === _hall.no,
      );

      return {
        ..._hall,
        checked: checkedHall?.checked ? true : false,
      };
    });
    return {
      ...item,
      checked: !!checkValue,
      hall: checkHallValue,
      booked: isBooked,
    };
  });

  async function getData(_page: number) {
    try {
      if (_page === 1) {
        setIsInit(true);
      }
      if (!!paging && paging.maxpage < _page && !!paging.maxpage) {
        return;
      }
      let requestParams: IWeddingListRequest = {
        search_name: searchText || "",
        open_yn: "Y",
        hide_yn: "N",
        offset: 20,
        category: "웨딩홀",
        page: _page,
        sorting: "abc",
      };

      if (recommend) {
        requestParams.location_1 = cityArray;
        requestParams.location_2 = userFittablaData.wantLocation;
        requestParams.filter_list = combinedArray;
      }
      const { data } = await getWeddingList(requestParams);

      const { Contructor, page } = data.result || {};
      if (data && Contructor && page) {
        setTotalPages(page.maxpage);
        setIsLoading(false);
        setPaging(page);
        const newDataState = (data.result?.Contructor || []).map(
          (company, i) => {
            const userHall = userHallData.find(
              (hall: THallList) => hall.name === company.name,
            );

            const checked = userHall ? userHall.checked : false;
            return {
              key: i,
              name: company.name,
              imgUrl: company.photo[0]?.img_url || "",
              checked: checked,
              contructor_no: company.no,
              hall: (company.wedding_hall || []).map((hall) => ({
                hall_name: hall.hall_name,
                hall_type: hall.hall_type,
                hall_term: hall.hall_term,
                hall_max: hall.hall_max,
                hall_style: hall.hall_style,
                meal_type: hall.meal_type,
                min_headcount: hall.min_headcount,
                hall_headcount: hall.hall_headcount,
                max_headcount: hall.max_headcount,
                checked: checked,
                no: hall.no,
              })),
            };
          },
        );
        if (_page <= 1) {
          setContructorList(newDataState);
        } else {
          setContructorList((prevList) => [...prevList, ...newDataState]);
        }
      }
    } catch (error) {
      console.error("error", error);
      toast.error(
        `데이터를 불러오는데 실패했습니다. \n 문제가 계속된다면 관리자에게 문의해주세요`,
      );
    } finally {
      setTimeout(() => setIsInit(false), 500);
    }
  }

  const handleItemClick = (item: THallList) => {
    setSelectArray([
      ...selectArray.filter(
        (data) => data.contructor_no !== item.contructor_no,
      ),
    ]);
  };

  const checkDateTimeInRange = (
    startDateTime: string,
    endDateTime: string,
  ): boolean => {
    const start = moment(startDateTime);
    const end = moment(endDateTime);
    const now = moment();
    const isInRange = now.isBetween(start, end, undefined, "[]");

    return isInRange;
  };
  async function getBlockStatus() {
    try {
      const { data, success } = await getWeddingHallBlock();

      if (!data && success) {
        return setReserveStatus({
          status: false,
          blockTime: "",
        });
      }
      const dateTime = moment(data?.endDateTime || "");
      if (
        checkDateTimeInRange(data.startDateTime, data.endDateTime) &&
        !!data.isDisplayed
      ) {
        return setReserveStatus({
          status: true,
          blockTime: dateTime.format("YYYY-MM-DD, h:mm"),
        });
      }
    } catch (error) {
      console.error("error", error);
      toast.error(
        `데이터를 불러오는데 실패했습니다. \n 문제가 계속된다면 관리자에게 문의해주세요`,
      );
    }
  }

  useEffect(() => {
    getData(page);
    getBlockStatus();
  }, [page, searchText]);

  useEffect(() => {
    setInquiryBoxList(recombinationList);
  }, [recombinationList]);

  useEffect(() => {
    getInquiryList("wedding");
  }, []);
  useInfiniteScroll({ page, setPage, ref: listRef, totalPages });

  return (
    <>
      {showPopup && (
        <>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0,0,0,0.4)",
              zIndex: "200",
            }}
            onClick={(e) => {
              e.stopPropagation();
              setShowAlert(false);
            }}
          ></div>
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "300px",
              height: "200px",
              zIndex: "200",
            }}
            onClick={(e) => {
              e.stopPropagation();
              setShowPopup(false);
            }}
          >
            <PopupModal
              title={"안내사항"}
              sub={`25년 하반기~26년 상반기 예식을 보시는 신랑,신부님!
                  대다수의 웨딩홀은 명절, 공휴일 주간을 제외하고
                  대부분 마감이거나 저녁 타임 예식만 남아있는 경우가 많습니다.

                  <h4>실시간으로 변동되는 모든 웨딩홀의 잔여타임을 
                  확인하는 것은 불가능하며 정확한 잔여타임은 
                  방문 상담을 통해 확인 가능합니다. </h4>
                  26년 하반기 예식 오픈한 웨딩홀의 경우,
                  상담 문의가 빠르게 마감되고 있으니 참고 
                  부탁 드립니다.

                  메이크마이웨딩 베뉴센터 드림`}
              closePopupToday={closePopupToday}
              close={() => setShowPopup(false)}
            />
          </div>
        </>
      )}
      {block && (
        <FixedModal
          title={"안내사항"}
          sub={`예약량이 많아 ${reserveStatus.blockTime} 이후부터 예약가능합니다.
        `}
          oneButton={{
            color: gray4,
            text: "뒤로가기",
            onClick: () => setBlock(false),
          }}
          onClick={() => setBlock(false)}
        />
      )}
      {showAlert && (
        <FixedModal
          title={"안내사항"}
          sub={`당일 노쇼 또는 반복된 취소로 패널티가 \n부여되어 메이크마이웨딩 제휴 업체 \n예약 문의가 불가합니다. \n또한 당일 노쇼 또는 반복된 취소 시, \n해당 업체 정책에 의거하여 업체에 직접 예약하실 경우에도 재예약 및 상담이 어려울 수 있으니 참고 부탁 드립니다.
        `}
          oneButton={{
            color: gray4,
            text: "뒤로가기",
            onClick: () => setShowAlert(false),
          }}
          onClick={() => setShowAlert(false)}
        />
      )}
      <Layout pdb={0}>
        <Title
          title={
            recommend
              ? "안내 받고 싶은 웨딩홀을 \n 모두 선택해 주세요."
              : "안내 받고 싶은\n웨딩홀을 모두 선택해 주세요."
          }
          subTitle="* 중복 선택 가능"
          style={
            recommend
              ? {
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  flexDirection: "column",
                  marginTop: "30px",
                }
              : { marginBottom: 8 }
          }
        />

        <div
          style={{
            wordBreak: "keep-all",
            fontSize: "12px",
            fontWeight: "400",
            color: "#646464",
          }}
        >
          * 이미 예약하신 웨딩홀의 경우 &nbsp;
          <span style={{ color: redLightColor }}>예약변경&nbsp;</span>
          부탁드립니다.
        </div>
      </Layout>
      {recommend ? null : !!decodedTxt ? (
        <StickyContent type="top">
          <SearchBox
            placeHolder="업체명을 검색해주세요."
            searchText={decodedTxt}
            setSearchText={setSearchText}
            status={decodedTxt !== "recommend" && !!decodedTxt}
          />
        </StickyContent>
      ) : (
        <StickyContent type="top">
          <SearchBox
            placeHolder="업체명을 검색해주세요."
            searchText={searchText}
            setSearchText={setSearchText}
          />
        </StickyContent>
      )}

      <Layout pdt={0} style={{ paddingBottom: "230px" }}>
        {isLoading ? (
          recommend ? (
            <div className={styles.recommendLoading}>
              <div
                className={styles.flexCenter}
                style={{
                  flexDirection: "column",
                  textAlign: "center",
                }}
              >
                <div>
                  <SvgLoadingImage />
                </div>
                <h1>
                  고객님이 원하시는 조건의 <br /> 웨딩홀을 찾았습니다!
                </h1>
              </div>
            </div>
          ) : (
            <div
              className={styles.flexCenter}
              style={{
                width: "100%",
                height: 300,
                padding: 50,
              }}
            >
              <Lottie animationData={loadingLottie} loop={true} />
            </div>
          )
        ) : (
          <>
            {recommend ?? (
              <ul className={styles.tagList}>
                {selectArray.map((item, i) => (
                  <li key={i}>
                    {item.name}
                    <button
                      onClick={() => {
                        handleItemClick(item);
                      }}
                    >
                      <img src="/images/delete.png" />
                    </button>
                  </li>
                ))}
              </ul>
            )}
            <ItemList
              data={viewContructorList}
              nowPage={paging?.cur}
              maxPage={paging?.maxpage}
              totalCount={paging?.maxcnt}
              selectComplete={selectComplete}
              setValue={({ contructor_no, contructor_hall_no }) => {
                const selectedValue = selectArray.find(
                  (item) => item.contructor_no === contructor_no,
                );
                const contructorData = contructorList.find(
                  (item) => item.contructor_no === contructor_no,
                );

                if (!contructorData) {
                  return;
                }

                if (selectedValue) {
                  if (contructor_hall_no) {
                    const selectedHall = selectedValue.hall?.find(
                      (item) => item.no === contructor_hall_no,
                    );

                    if (selectedHall) {
                      setSelectArray([
                        ...selectArray.map((item) =>
                          item.contructor_no === contructor_no
                            ? {
                                ...item,
                                hall: (item.hall || [])
                                  .map((_hall) =>
                                    _hall.no === contructor_hall_no
                                      ? { ..._hall, checked: !_hall.checked }
                                      : _hall,
                                  )
                                  .filter((_hall) => _hall.checked === true),
                                title: item.name,
                              }
                            : item,
                        ),
                      ]);
                    } else {
                      const hallData = contructorData?.hall?.find(
                        (item) => item.no === contructor_hall_no,
                      );
                      if (!hallData) {
                        return;
                      }
                      setSelectArray([
                        ...selectArray.map((item) =>
                          item.contructor_no === contructor_no
                            ? {
                                ...item,
                                hall: [...(item.hall || []), { ...hallData }],
                                title: item.name,
                              }
                            : item,
                        ),
                      ]);
                    }
                  } else {
                    setSelectArray([
                      ...selectArray.filter(
                        (item) => item.contructor_no !== contructor_no,
                      ),
                    ]);
                  }
                } else {
                  setSelectArray([
                    ...selectArray,
                    { ...contructorData, checked: true },
                  ]);
                }
              }}
            />
            {(contructorList || []).length > 14 && <div ref={listRef} />}
          </>
        )}
      </Layout>
      <StickyContent type="bottom">
        <ul className={styles.searchEmpty}>
          {recommend && (
            <li>
              <p>홀을 더 알아보고 싶다면?</p>
              <a
                href="https://www.makemywedding-pc.co.kr/wedding/hall"
                target="_self"
                className={styles.infoButton}
              >
                홀 알아보기 <Icon name="arrowRight" color="#646464" />
              </a>
            </li>
          )}
          <li>
            <p>원하는 웨딩홀이 없다면?</p>
            <a
              onClick={() => navigate("/wedding/date?txt=nonexistent")}
              target="_self"
            >
              문의하기
              <Icon name="arrowRight" color="#79C5BC" />
            </a>
          </li>
          <li>
            <p>웨딩홀 추천 받고 싶다면?</p>
            <a className="channel-recommand-button">
              추천 요청하기 <Icon name="arrowRight" color="#79C5BC" />
            </a>
          </li>
        </ul>
        <BottomButton
          nextButtonDisabled={
            reArrangeList.length + selectArray.length > 5 ||
            selectArray.length === 0
          }
          nextButtonEvent={() => {
            if (user?.wedding_block_yn === "Y") {
              return setShowAlert(true);
            }
            if (!!reserveStatus.status) {
              return setBlock(true);
            }
            if (containsEmptyArray.length > 0) {
              toast(containsEmptyArray[0].name + ` 홀타입 선택해주세요`);
              return;
            } else {
              // 장바구니 생기면 추후 교체
              navigate("/wedding/date");
            }
          }}
          // 장바구니 생기면 추후 교체
          nextButtonText={recommend ? "예약하러 가기" : ""}
        ></BottomButton>
      </StickyContent>
      <ToastContainer
        position="bottom-center"
        limit={1}
        closeButton={false}
        autoClose={1000}
        theme="light"
      />
      {reArrangeList.length + selectArray.length > 5 && (
        <Alert text="웨딩홀 견적요청은 최대 5개까지 가능합니다.\n 추가 요청은 챗봇으로 문의주세요." />
      )}
    </>
  );
}
